import { Component } from '@angular/core';
import { ClarityModule } from "@clr/angular";
import { AlertComponent } from "./alert/alert.component";
import { HeaderComponent } from "./header/header.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { RouterOutlet } from "@angular/router";
import { FooterComponent } from "./footer/footer.component";

@Component({
  selector: 'app-core',
  standalone: true,
  imports: [
    ClarityModule,
    AlertComponent,
    HeaderComponent,
    SidenavComponent,
    RouterOutlet,
    FooterComponent,
  ],
  templateUrl: './core.component.html',
  styleUrl: './core.component.sass'
})
export class CoreComponent {

}
